import { atom } from 'jotai';
import { TCustomerAccountEntity } from '../types/accounts.types';

type TAccountsAtomValue = {
  updateTableStatus: boolean;
  accounts: TCustomerAccountEntity[] | [];
  accountNumber?: string;
};

export const accountsAtom = atom<TAccountsAtomValue>({
  updateTableStatus: false,
  accounts: [],
  accountNumber: '',
});
